<div>
  <button title="{{'labels.save' | translate}}" (click)="closeDialog()" mat-icon-button color="warn" aria-label="icon-button save">
    <mat-icon>close</mat-icon>
  </button>
</div>
<cdk-virtual-scroll-viewport style="margin-left: 3%; margin-right: 3%" id="style-4" itemSize="6"
                             class="cdkD"><div>
  <mat-form-field>
    <mat-label>{{'labels.find' | translate}}</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="{{'labels.find' | translate}}..." #input>
  </mat-form-field>
</div>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index" matColumnDef="{{disCol}}">
      <ng-container *ngIf="disCol != 'Azioni'">
            <th  mat-sort-header mat-header-cell *matHeaderCellDef>{{(disCol.substr(disCol.indexOf(',') + 1, disCol.length))}}</th>
        <td mat-cell *matCellDef="let element">{{element[disCol]}}
        </td>
      </ng-container>
      <ng-container *ngIf="disCol == 'Azioni'">
        <th mat-header-cell *matHeaderCellDef>{{disCol}}</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="{{'labels.actionMask'}}">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">

            <button mat-menu-item (click)="deleteField(element)">
              <mat-icon>delete</mat-icon>
              <span>Elimina</span>
            </button>

          </mat-menu>
        </td>
      </ng-container>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">{{'labels.noRecord' | translate}}: "{{input.value}}"</td>
    </tr>
  </table>
</div>
</cdk-virtual-scroll-viewport>
